import axios from 'axios';
import { main_server_ip, marketting_main_server_ip } from '../communication_system/communication_ips';
import RefreshCheckApi from '../communication_system/axios_apis/refresh_check/refresh_check_api';

const ComUtil = require('./comUtil');

/** URL */
let userPayInfoRefundCheckUrl = 'https://senor.co.kr/userPayInfo/refund/check';
let mainRefundUrl = 'https://senor.co.kr/userPayInfo/refund/check';

if (!ComUtil.IsProduction()) {
    // testLoginUrl = 'https://test.senor.co.kr/userPayInfo/refund/check';
    userPayInfoRefundCheckUrl = 'https://test.senor.co.kr/userPayInfo/refund/check';
    // mainRefundUrl = 'https://test.senor.co.kr/userPayInfo/refund/check';
}

const hasText = (value) => value !== undefined && value !== null && String(value).trim() !== '';
const trimText = (value) => (hasText(value) ? String(value).trim() : '');

export const isZeroRefundAmount = (data) => {
    const refundAmount = hasText(data?.refund_amount) ? data.refund_amount : data?.amount;
    if (!hasText(refundAmount)) return false;

    const amount = Number(refundAmount);
    return Number.isFinite(amount) && amount === 0;
};

export const isRefundAccountRequired = (data) => [1, 4].includes(Number(data?.pay_type_number)) && !isZeroRefundAmount(data);

export const getMissingRefundAccountMessage = (data) => {
    if (!isRefundAccountRequired(data)) return null;
    if (!hasText(data?.bank_code)) return '환불 은행을 입력해 주세요.';
    if (!hasText(data?.account_no)) return '환불 계좌번호를 입력해 주세요.';
    if (!hasText(data?.refund_user_name)) return '환불 예금주를 입력해 주세요.';
    return null;
};

export const buildRefundRequest = (data) => {
    const request = {
        pay_id: data.pay_id,
        apply_yn: true,
        refund_remark: '관리자 취소',
        account_info: {},
    };

    if (isRefundAccountRequired(data)) {
        request.account_info = {
            account_num: trimText(data.account_no),
            name: trimText(data.refund_user_name),
            bank_num: trimText(data.bank_code),
        };
    }

    return request;
};

const refreshAfterRefund = (ref, refreshFunc) => {
    if (typeof refreshFunc === 'function') {
        refreshFunc();
        return;
    }
    ref?.current?.refresh?.();
};

/** 환불신청 및 환불처리 */
export const applyRefund = async (data, ref, adminId = null, refreshFunc = null, scheduleRefundContext = null) => {
    console.log('refund!', data);

    if (data.pay_contents === 13) {
        const keyRes = RefreshCheckApi.post('/auth/testLogin', {
            id: adminId,
        });

        // 환불 했을때 결제 내역에서 어떻게 나오는지 봐야함.
        keyRes
            .then((response) => {
                let userToken = response.data.data.access_token;

                axios
                    .post(
                        main_server_ip + '/userPayInfo/pay/refund',
                        {
                            userPayInfoId: data.pay_id,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${userToken}`,
                            },
                        },
                    )
                    .then((res) => {
                        alert('환불 신청이 완료되었습니다.');
                    })
                    .catch((err) => {
                        console.error(err);
                        alert(`[ERROR]${err.response?.data}`);
                    });
            })
            .catch((err) => {
                console.error(err);
                alert('[사용자 인증 에러]관리자에게 문의하세요.');
            });
    } else {
        const payStatus = Number(data.pay_status_number);
        if (![2, 3, 8].includes(payStatus)) {
            alert('현재 결제 상태에서는 환불을 처리할 수 없습니다.');
            return false;
        }

        if (payStatus === 8 && Number(data.pay_type_number) !== 1) {
            alert('현재 결제 방식에서는 운영진 취소 환불을 처리할 수 없습니다.');
            return false;
        }

        if (scheduleRefundContext && !(Number(data.pay_contents) === 6 && [2, 3].includes(payStatus)
            && String(scheduleRefundContext.adminRole) === '1' && Number(scheduleRefundContext.adminAvailable) === 1
            && [adminId, scheduleRefundContext.payId, scheduleRefundContext.userId, scheduleRefundContext.contentsId]
                .every((id) => Number.isSafeInteger(Number(id)) && Number(id) > 0)
            && Number(data.pay_id) === scheduleRefundContext.payId && Number(data.user_id) === scheduleRefundContext.userId
            && Number(data.gatheringInfo?.gathering_contents_id) === scheduleRefundContext.contentsId)) {
            alert('선택한 결제와 관리자 정보를 확인한 뒤 다시 시도해 주세요.');
            return false;
        }

        const missingRefundAccountMessage = getMissingRefundAccountMessage(data);
        if (missingRefundAccountMessage) {
            alert(missingRefundAccountMessage);
            return false;
        }

        const param = buildRefundRequest(data);
        try {
            let response;
            if (scheduleRefundContext) {
                param.target_user_id = scheduleRefundContext.userId;
                param.contents_id = scheduleRefundContext.contentsId;
                response = await RefreshCheckApi.post(`${marketting_main_server_ip}adminRequest/payment/schedule-refund`, param);
            } else {
                let userToken;
                try {
                    const authResponse = await RefreshCheckApi.post('/auth/testLogin', { id: data.user_id });
                    userToken = authResponse.data?.data?.access_token;
                } catch (err) {
                    console.error(err);
                    alert('[사용자 인증 에러]관리자에게 문의하세요.');
                    return false;
                }
                if (!userToken) {
                    alert('인증토큰 발급 후 환불요청이 가능합니다.');
                    return false;
                }
                const requestUrl = payStatus === 2 ? mainRefundUrl : userPayInfoRefundCheckUrl;
                response = await axios.post(requestUrl, param, { headers: { Authorization: `Bearer ${userToken}` } });
            }

            const result = response.data;
            if (result?.ok === false) {
                throw new Error(result?.message || '환불 요청에 실패했습니다.');
            }

            if (result?.status === 'processing') {
                alert('환불 신청이 접수되어 처리 중입니다.');
                return false;
            }

            if (result?.status !== 'already_refunded' || result?.reconciled !== true) {
                throw new Error('환불 처리 결과를 확인할 수 없습니다. 결제 상세에서 상태를 확인한 뒤 다시 시도해 주세요.');
            }

            alert('환불 처리가 완료되었습니다.');
            refreshAfterRefund(ref, refreshFunc);
            return true;
        } catch (err) {
            console.error(err);
            const errorMessage = [err.response?.data?.message, err.response?.data, err.message]
                .find((message) => typeof message === 'string' && message.trim());
            alert(`[환불처리 에러]${errorMessage || '관리자에게 문의하세요.'}`);
            return false;
        }
    }
};

/** 환불신청 및 환불처리(레거시) */
export const regacyApplyRefund = (data) => {
    const response = RefreshCheckApi.post('/auth/testLogin', {
        id: data.user_id,
    });
    response
        .then((res) => {
            let userToken = res.data.data.access_token;

            let param = {
                pay_id: data.pay_id,
                apply_yn: true,
                refund_remark: '관리자 취소',
            };

            if (!userToken) {
                return alert('인증토큰 발급 후 환불요청이 가능합니다.');
            }
            if (!data.bank_code) {
                return alert('은행정보가 존재하지 않습니다.');
            }

            if (data.pay_type_number === 0 || data.pay_type_number === -1) {
                const response = axios.post(userPayInfoRefundCheckUrl, param, {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                    },
                });

                response.then((res) => {});
            } else if (data.pay_type_number === 1 || data.pay_type_number === 4) {
                param = {
                    pay_id: data.pay_id,
                    apply_yn: true,
                    refund_remark: '관리자 취소',
                    account_info: {
                        account_num: data.account_no, // 계좌번호
                        name: data.refund_user_name, // 예금주
                        bank_num: String(data.bank_code), // 은행
                    },
                };

                const response = axios.post(userPayInfoRefundCheckUrl, param, {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                    },
                });

                response.then((res) => {
                    if (res.data.ok) {
                        alert('환불신청이 완료되었습니다.');
                    }
                });
            }
        })
        .catch((error) => {
            console.error(error);
            alert('[Error] 관리자에게 문의 바랍니다.');
        });
};
